<template>
    <div>
        <embedded-modules-component
            :column="column"
            :state="state"
            :config="Object.assign(config, {showValue: false})"
            :embeddedModules="embeddedModules"
            :routeName="routeName"
            :row="row"
        ></embedded-modules-component>

        <ProductLinkComponent v-if="row['link']"
            :config="{linkIndex: 'link'}"
            :row="row"
            :column="column"
            :title="'Your product identifying data'"
        ></ProductLinkComponent>
        <template v-else>
            <span class="product-name" v-popover:tooltip="t('Your product identifying data')">{{ row['name'] }}</span>
            <br>
        </template>

        <template v-if="row['shop_code']">
            <span class="details">
                <strong class="details">Index: </strong>
                {{ row['shop_code'] }}
            </span>
        </template>
        <template v-if="row['ean']">
            <br>
            <span class="details">
                <strong>EAN: </strong>{{ row['ean'] }}
            </span>
        </template>
    </div>
</template>

<script>

import EmbeddedModulesComponent from "./EmbeddedModulesComponent";
import ProductLinkComponent from "./ProductLinkComponent";

export default
{
    components: {ProductLinkComponent, EmbeddedModulesComponent},
    props: {
        column: {
            type: Object,
        },
        state: {
            type: Object
        },
        config: {
        },
        embeddedModules: {
            type: Array
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {

        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="sass" scoped>
    .details {
        font-size: 0.9em;
    }
    .product-name {
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// PrimaryProductDetailComponent.vue?183e25ae